import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {useCurrentLocale, useLocalizedLabels} from "widget-shared-components-library";
import SearchResultsLabels from "./SearchResults.Labels";
import mapping from "../../config/mapping";
import useAxiosInstance from "../../hooks/useAxiosInstance";
import locales from "../../assets/const/locales";

const useSearchResults = () => {
    const lang = useCurrentLocale();
    const labels = useLocalizedLabels(SearchResultsLabels);
    const axiosInstance = useAxiosInstance();

    const [searchQuery, setSearchQuery] = useState('');
    const [selectedTabOption, setSelectedTabOption] = useState('products');

    const initialedObject = {
        items: [],
        count: 0
    };

    const [devices, setDevices] = useState(initialedObject);
    const [rateplans, setRateplans] = useState(initialedObject);
    const [articles, setArticles] = useState(initialedObject);
    const [support, setSupport] = useState(initialedObject);
    const [filterItems, setFilterItems] = useState([]);
    const [filtersForRequest, setFiltersForRequest] = useState([]);
    const [lastRequest, setlastRequest] = useState(null);
    const [expandedSubCategories, setExpandedSubCategories] = useState({});
    const hasLoaded = useRef(false);


    // Pagination state and constants
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState([4]);
    const [displayPages, setDisplayPages] = useState([]);

    // Product per page dropdown
    const productsPerPage = mapping.getProductsPerPage(labels);

    // Product sorting dropdown map
    const [productSorting, setProductSorting] = useState([]);


    useEffect(() => {
        callSearchHubForSortingOptions()

    }, [])
    // pagination
    const [selectedProductsPerPage, setSelectedProductsPerPage] = useState({label: labels['perPage12'], value: 12});
    const [selectedProductsSorting, setSelectedProductsSorting] = useState('');
    const callSearchHubForSortingOptions = () => {
        axiosInstance.get(`${process.env.REACT_APP_API_SORTING_OPTIONS}?language=${(lang === locales.ENGLISH || lang?.toLowerCase() === 'en') ? 'en' : 'gr'}`)
            .then((response) => {
                setProductSorting(response?.data?.sortingOptionsMap);
                setSelectedProductsSorting( response?.data?.sortingOptionsMap && "score" in response?.data?.sortingOptionsMap
                    ? "score"
                    : Object.keys(response?.data?.sortingOptionsMap)[0]);
                console.log(response?.data?.sortingOptionsMap && "score" in response?.data?.sortingOptionsMap
                    ? "score"
                    : Object.keys(response?.data?.sortingOptionsMap)[0]);
                updateURL("sort", response?.data?.sortingOptionsMap && "score" in response?.data?.sortingOptionsMap
                    ? "score"
                    : Object.keys(response?.data?.sortingOptionsMap)[0]);
            })
            .catch((error) => {
                console.error(error);
                setProductSorting([]);
            });
    }




    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);


    const handleSelectionClick = (option) => {
        setCurrentPage(1);
        updateURL("selectedTabOption", option);
        setSelectedTabOption(option);
    };

    const updateURL = (name, value) => {
        const currentURL = new URL(window.location.href);
        currentURL.searchParams.set(name, value);
        window.history.pushState({}, '', currentURL);
    }

    // Pagination handlers
    const handlePageChange = (pageNum) => {
        setCurrentPage(pageNum);
        updateURL("page", pageNum);
    };
    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            updateURL("page", currentPage - 1);
        }
    };
    const handleNext = () => {
        if (currentPage < totalPages[totalPages.length - 1]) {
            setCurrentPage((prev) => prev + 1);
            updateURL("page", currentPage + 1);
        }

    };

    const onPageChange = (page) => {
        setDisplayPages(prevArray => prevArray.map(num => num + 1))
        setCurrentPage(page);
    }
    const handleLearnMore = (productId, skuId, type) => {
        switch (type) {
            case 'rateplan':
                window.location.href = "eshop/global/gadgets/configurator.jsp?productId=" + productId;
                break;
            case 'device':
                window.location.href = "eshop/global/gadgets/productDetailsTangible.jsp?productId=" + productId + "&skuId=" + skuId;
                break;
        }

    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1200);
            setScreenWidth(window.innerWidth)
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleResponse = (data) => {
        setDevices(data?.devices);
        setRateplans(data?.rateplans);
        setArticles(data?.articles);
        setSupport(data?.support);
        setFilterItems(data?.filters);
        const expandedCategories = data.filters.reduce((acc, item) => {
            if (item?.title === 'Κατηγορία' && item?.items && item?.items.length > 0) {
                const processSubItems = (subItems) => {
                    subItems.forEach(subItem => {
                        acc[subItem?.title] = true;
                        if (subItem?.items && subItem.items.length > 0) {
                            processSubItems(subItem?.items);
                        }
                    });
                };
                processSubItems(item?.items);
            }
            return acc;
        }, {});
        setExpandedSubCategories(expandedCategories);
        setTotalPages(Array.from({length: data?.pages}, (_, i) => i + 1));
    }

    const localHost = 'http://localhost:4200';
    const origin = process.env.REACT_APP_SEARCH_SUPPORT_ORIGIN_URL;
    const isLocalEnv = process.env.NODE_ENV === 'development';
    const baseUrl = isLocalEnv ? localHost : origin;

    const [parametersReady, setParametersReady] = useState(false);

    const prepareRequest = (size, order, page, collection, q, filters) => {
        setParametersReady(false);

        if (filters) {
            setFiltersForRequest(filters.map(([property, value]) => ({
                property: property,
                value: value
            })));
        }

        if (q) {
            setSearchQuery(q);
        }

        if (collection) {
            setSelectedTabOption(collection);
        }

        if (size) {
            prepareParameters(size, productsPerPage, setSelectedProductsPerPage);

        }
        if (order) {
            prepareSortingParameters(order, productSorting, setSelectedProductsSorting);
        }

        if (page) {
            setCurrentPage(Number(page));
        }
        setParametersReady(true);

    }

    const prepareParameters = (param, options, setVariable) => {
        const convertToNum = Number(param);
        const object = options.find((item) => item.value === convertToNum);

        if (object) {
            setVariable(object);
        } else {
            setVariable(null);
        }
    }

    const prepareSortingParameters = (sortingChoice, productSortingMap) => {
        setSelectedProductsSorting(sortingChoice)
    }

    const search = (filters) => {
        const request = {
            q: searchQuery,
            collectionSet: selectedTabOption,
            filters: filters,
            size: selectedProductsPerPage?.value,
            order: selectedProductsSorting,
            page: currentPage,
            language: lang,
            flow: "searchResults"
        };
        console.log("request", request);
        if (request !== lastRequest) {
            axios
                .post(`${baseUrl}/search-hub/searchResults`, request
                )
                .then((response) => {
                    setlastRequest(request);
                    console.log("searchResultsResponse", response?.data)
                    handleResponse(response?.data);
                })
                .catch((error) => {
                    console.error(error);
                });
        }

    };

    useEffect(() => {
        if (!hasLoaded.current) {
            const currentURL = new URLSearchParams(window.location.search);
            const allParams = {};
            for (const [key, value] of currentURL.entries()) {
                allParams[key] = value;
            }
            const unknownVariables = Object.entries(allParams).filter(([key]) =>
                !['size', 'sort', 'page', 'selectedTabOption', 'q', 'id', 'value'].includes(key)
            );

            prepareRequest(
                currentURL.get('size'),
                currentURL.get('sort'),
                currentURL.get('page'),
                currentURL.get('selectedTabOption'),
                currentURL.get('q'),
                unknownVariables
            )
            hasLoaded.current = true; // Ensure this runs only once

        }
    }, []);


    return {
        handlePageChange,
        handlePrevious,
        handleNext,
        selectedTabOption,
        totalPages,
        handleSelectionClick,
        onPageChange,
        currentPage,
        displayPages,
        isMobile,
        screenWidth,
        searchQuery,
        devices,
        articles,
        support,
        rateplans,
        filterItems,
        setDisplayPages,
        search,
        updateURL,
        selectedProductsPerPage,
        selectedProductsSorting,
        setSelectedProductsPerPage,
        setSelectedProductsSorting,
        setCurrentPage,
        handleLearnMore,
        labels,
        parametersReady,
        filtersForRequest,
        expandedSubCategories,
        setExpandedSubCategories,
        productSorting,
        lang
    };
}
export default useSearchResults;
